import { useCallback, useState } from "react";

import { useQueryClient } from "react-query";
import { UserContextClient } from "services/motorpoint/user-context-api";
import { CustomerId, UserContextId } from "services/motorpoint/user-context-api/types";

const userContextClient = new UserContextClient({
    useEnv: true,
});

const useUserContextApi = () => {
    const [error, setError] = useState<string | null>(null);
    const queryClient = useQueryClient();

    const getByCustomerIdBind = userContextClient.getByCustomerId.bind(userContextClient);
    const getByIdBind = userContextClient.getById.bind(userContextClient);

    const getByCustomerId = useCallback(async (params: CustomerId) => {
        try {
            const data = await queryClient.fetchQuery({
                queryKey: "userContext",
                queryFn: () => getByCustomerIdBind(params),
            });
            return data;
        } catch (error) {
            setError("Could not get userContext by customerId");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getById = useCallback(async (params: UserContextId) => {
        try {
            const data = await queryClient.fetchQuery({
                queryKey: "userContext",
                queryFn: () => getByIdBind(params),
            });
            return data;
        } catch (error) {
            setError("Could not get userContext by userContextId");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { error, getByCustomerId, getById };
};

export default useUserContextApi;
